import {CandidateQualificationQuestionnaireCompetenceRateModel} from './candidate-qualification-questionnaire-competence-rate.model';
import {CandidateQualificationQuestionnaireLocationModel} from './candidate-qualification-questionnaire-location.model';

export class CandidateQualificationQuestionnaireModel {
  referenceNumber: string;
  jobOrderNumber: string;
  jobOrderClient: string;
  jobOrderDescription: string;
  currentJobLocationCityDictId: string;
  currentEmploymentForm: number;
  currentSalary: number;
  currentSalaryType: number;
  currentSalaryMode: number;
  expectedEmploymentForm: number;
  expectedSalary: number;
  expectedSalaryMax: number;
  expectedSalaryType: number;
  expectedSalaryMode: number;
  remoteWork: boolean;
  noticePeriodType: number;
  workTime: number;
  desiredPositionsDictId: number[] = [];
  offerRating: number;
  competenceRates: CandidateQualificationQuestionnaireCompetenceRateModel[] = [];
  candidateRating: string;
  currentProjectAdvantages: string;
  currentProjectDisadvantages: string;
  selfDevelopmentDirection: string;
  locations: CandidateQualificationQuestionnaireLocationModel[] = [];
  otherRecruitments: string;
  comments: string;
  interviewDate: string;
  status: string;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/interviews/questionnaires/candidate-qualification-questionnaire/candidate-qualification-questionnaire.model.ts